import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main>
        {/* Peter Collingwood Exhibition Section */}
        <section className="exhibition-hero">
          <div className="exhibition-hero__media">
            <video autoPlay muted loop playsInline>
              <source src="/main/main1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </section>

        {/* Exhibition Details Section */}
        <section className="exhibition-details">
          <div className="exhibition-details__container">
            <h2 className="exhibition-details__title">PETER COLLINGWOOD</h2>
            <h3 className="exhibition-details__subtitle">
              MACROGAUZE WALL HANGINGS
            </h3>
            <h4 className="exhibition-details__event">
              EXHIBITION & CALENDAR 2026
            </h4>

            <div className="exhibition-details__content">
              <p>
                The Margotal Calendar 2026 celebrates the pioneering work of
                British weaver Peter Collingwood.
              </p>

              <p>
                Collingwood's Macrogauze wall hangings fused economy of
                production with design elegance. Using specially constructed
                looms and multiple rigid heddles, he invented a new weaving
                language that emphasised structure and geometric form.
              </p>

              <p>
                Our Wigmore Street shop is currently hosting an exhibition of
                Macrogauze wall hangings offering a rare opportunity to view
                these intricate works up close.
              </p>
            </div>
          </div>
        </section>

        {/* Autumn Winter Collection Section */}
        <section className="collection-section">
          <div className="collection-section__grid">
            <div className="collection-section__item">
              <img
                src="/main/main2-1.jpeg"
                alt="Shop Women"
                className="collection-section__image"
              />
              <Link
                onClick={toTop}
                to="/shop"
                className="collection-section__link"
              >
                SHOP WOMEN
              </Link>
            </div>
            <div className="collection-section__item">
              <img
                src="/main/main2-2.jpeg"
                alt="Shop Men"
                className="collection-section__image"
              />
              <Link
                onClick={toTop}
                to="/shop"
                className="collection-section__link"
              >
                SHOP MEN
              </Link>
            </div>
          </div>
          <div className="collection-section__title">
            <h3>AUTUMN WINTER 2025 COLLECTION</h3>
          </div>
        </section>

        {/* Spring Summer 2026 Collection Preview */}
        <section className="collection-preview">
          <div className="collection-preview__media">
            <video autoPlay muted loop playsInline>
              <source src="/main/main3.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </section>

        {/* Collection Description */}
        <section className="collection-description">
          <div className="collection-description__container">
            <h3 className="collection-description__title">
              A COLLECTION THAT ACKNOWLEDGES PAST AND PRESENT
            </h3>
            <p className="collection-description__text">
              Defined by Margotal's signature relaxed proportions, lightweight
              heritage fabrics and muted colour palette.
            </p>
          </div>
        </section>

        {/* Black Denim Section */}
        <section className="product-feature">
          <div className="product-feature__media">
            <img
              src="/main/main4.jpeg"
              alt="Black Denim"
              className="product-feature__image"
            />
          </div>
        </section>

        {/* MHL Shop Links Section */}
        <section className="mhl-shop-section">
          <div className="mhl-shop-section__grid">
            <div className="mhl-shop-section__item">
              <img
                src="/main/main5-1.jpeg"
                alt="MHL Women"
                className="mhl-shop-section__image"
              />
              <Link
                onClick={toTop}
                to="/shop"
                className="mhl-shop-section__link"
              >
                SHOP MHL. WOMEN
              </Link>
            </div>
            <div className="mhl-shop-section__item">
              <img
                src="/main/main5-2.jpeg"
                alt="MHL Men"
                className="mhl-shop-section__image"
              />
              <Link
                onClick={toTop}
                to="/shop"
                className="mhl-shop-section__link"
              >
                SHOP MHL. MEN
              </Link>
            </div>
          </div>
        </section>

        {/* Find Shop Section */}
        <section className="find-shop-section">
          <div className="find-shop-section__grid">
            <div className="find-shop-section__item">
              <img
                src="/main/main6-1.jpeg"
                alt="Margotal Shop"
                className="find-shop-section__image"
              />
              <Link
                onClick={toTop}
                to="/shops"
                className="find-shop-section__link"
              >
                FIND A Margotal SHOP
              </Link>
            </div>
            <div className="find-shop-section__item">
              <img
                src="/main/main6-2.jpeg"
                alt="MHL Shop"
                className="find-shop-section__image"
              />
              <Link
                onClick={toTop}
                to="/shops"
                className="find-shop-section__link"
              >
                FIND A MHL. SHOP
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </body>
  );
}

export default Main;
